module.exports = __webpack_public_path__ + "static/media/Left Hip Cartoon.1a7dcb9a.png";